import React from "react";

const ModalClose = props => (
  <div className="modal__close" onClick={props.handleClick}>
    <svg className="bars-icon" viewBox="0 0 24 24">
      <path d="M1,1 L22,22 M1,22 L22,1" stroke="#000" strokeWidth="1" />
    </svg>
  </div>
);

export default ModalClose;



// WEBPACK FOOTER //
// ./src/components/modals/ModalClose.js